import { useTranslation } from 'react-i18next';
import { ContractsListPanel } from '@/pages/contracts/contracts-list-panel';

interface CustomerContractsTabProps {
	customerId: string;
	isActive: boolean;
}

export const CustomerContractsTab = ({
	customerId,
	isActive
}: CustomerContractsTabProps) => {
	const { t } = useTranslation('customers');

	return (
		<ContractsListPanel
			customerId={customerId}
			isActive={isActive}
			emptyMessage={t('contractsTab.empty')}
		/>
	);
};
